var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.75949C0 0.34004 0.330191 0 0.737496 0H1.45969C2.82345 0 3.9738 1.0458 4.14295 2.4394L4.33852 4.05063H18.2789C19.3309 4.05063 20.1367 5.01422 19.9806 6.08567L18.9263 13.3245C18.7277 14.6877 17.5906 15.6962 16.252 15.6962H6.85611C5.51757 15.6962 4.38044 14.6877 4.18189 13.3245L2.95814 4.92279L2.95567 4.90433L2.67935 2.6278C2.60246 1.99435 2.07957 1.51899 1.45969 1.51899H0.737496C0.330191 1.51899 0 1.17895 0 0.75949ZM4.54384 5.56962L5.64056 13.0992C5.73081 13.7188 6.24768 14.1772 6.85611 14.1772H16.252C16.8605 14.1772 17.3774 13.7188 17.4676 13.0992L18.5219 5.86034C18.5442 5.70727 18.4292 5.56962 18.2789 5.56962H4.54384Z",
    fill: "#34415A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.454 18.9873C17.454 19.5466 17.0137 20 16.4707 20C15.9276 20 15.4874 19.5466 15.4874 18.9873C15.4874 18.4281 15.9276 17.9747 16.4707 17.9747C17.0137 17.9747 17.454 18.4281 17.454 18.9873Z",
    fill: "#34415A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62077 18.9873C7.62077 19.5466 7.18052 20 6.63745 20C6.09437 20 5.65412 19.5466 5.65412 18.9873C5.65412 18.4281 6.09437 17.9747 6.63745 17.9747C7.18052 17.9747 7.62077 18.4281 7.62077 18.9873Z",
    fill: "#34415A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketIcon);
export default __webpack_public_path__ + "static/media/market-icon.a0e4581b3ab5cc8e58b2d784d1255ac0.svg";
export { ForwardRef as ReactComponent };